import ReactDOM from 'react-dom/client';
import React from 'react';
import './polyfills/process-global'; // Must be first to polyfill process
import './polyfills/buffer-global'; // Must be second to polyfill Buffer
import './sentry-init';
import './analytics-init';
import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'config/apolloClient';
import trackUserProperties from './utils/analytics/trackUserProperties';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Track user properties for analytics.
trackUserProperties();
